import { TextField } from "@mui/material";
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { getAttributeMaxLengthRule, validateAttributeInputForType } from "../../services/common/AttributeUtils";
import useStyles from "../../style/js-style/components/attributes/AttributeTextFieldInputStyle";
import { ATTRIBUTE_MAX_TEXT_VALUE_LENGTH } from "services/common/Constants";

// Input For Types : String, Integer, Decimal and Percentage.
const AttributeTextFieldInput = ({ type, setSelectedAttribute = () => {}, save = () => {} }) => {
  const formMethods = useFormContext();
  const { classes } = useStyles();

  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    if (!isFocused) {
      setSelectedAttribute(null);
      save();
    }
    // eslint-disable-next-line
  }, [isFocused]);

  return (
    <Controller
      control={formMethods.control}
      name="value"
      rules={{
        maxLength: getAttributeMaxLengthRule(
          "theValue",
          ATTRIBUTE_MAX_TEXT_VALUE_LENGTH
        ),
        validate: (value) => validateAttributeInputForType(type, value),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          id="attribute-value-id"
          variant="outlined"
          fullWidth
          autoFocus
          className={classes.input}
          sx={{
            height: "100%",
            "& .MuiOutlinedInput-root": {
              border: "none",
              borderRadius: "0 12px 12px 0",
              fontSize: "14px",
            },
            "& .MuiFormHelperText-root": {
              position: 'absolute',
              bottom: "-18px",
              left: "-10px",
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            },
          }}
          placeholder={i18next.t("notSpecified")}
          error={!!formMethods.formState.errors.value}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          helperText={
            !!formMethods.formState.errors.value
              ? formMethods.formState.errors.value.message
              : ""
          }
        />
      )}
    />
  );
};
export default AttributeTextFieldInput;
